<template>
  <div id="shop_order">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">积分兑换订单确认</div>
    </div>
    <!-- hotgkt end -->
    <div class="main" id="main_content">
      <dl class="main_shop clearfix">
        <dt><img :src="CoverImg" /></dt>
        <dd>
          <h3>{{ title }}</h3>
          <p>数量：{{ num }}</p>
          <p class="red">合计：{{ xyjf }}</p>
          <p>
            配送方式：<span v-if="ParentType == 65">实物商品，快递寄发</span
            ><span v-else>虚拟商品，到“个人-激活兑换”查看</span>
          </p>
        </dd>
      </dl>
      <div class="shop_heng"></div>
      <div class="Shipping_address">
        <div v-if="ParentType == 65">
          <h2>选择收货地址</h2>
          <div class="news_address" v-if="addresslength">
            <el-button icon="el-icon-plus" round @click="news_address"
              >新增收货地址</el-button
            >
          </div>
          <ul class="clearfix">
            <li
              v-for="(item, index) in address"
              :class="{ btn2: default1 == index }"
              :key="item.Id"
              @click="xuanze(index)"
            >
              <h3>{{ item.Name }}</h3>
              <p>{{ item.Region }}{{ item.DetailedAddress }}{{ item.Phone }}</p>
              <span @click="modify(index)">修改</span>
            </li>
          </ul>
          <div class="gl_address"><span>管理收货地址</span></div>
        </div>
        <div class="shop_btn clearfix">
          <span @click="cancel_order">取消订单</span>
          <button @click="submit_order">提交订单</button>
        </div>
      </div>
      <!-- Shipping_address -->
    </div>
    <!-- main end -->
    <div
      class="zzc"
      v-if="address_zzc"
      @click="address_close('save_address')"
    ></div>
    <div class="address_xg" v-if="address_hidden">
      <div class="address_close" @click="address_close('save_address')">
        <img src="../../assets/login/close.png" />
      </div>
      <h2>
        <span v-if="news">新增收货地址</span><span v-else>修改收货地址</span>
      </h2>
      <el-form
        :model="save_address"
        :rules="rules"
        ref="save_address"
        label-width="80px"
        class="demo-save_address"
      >
        <el-form-item label="收货人" prop="name">
          <el-input
            v-model="save_address.name"
            placeholder="请输收货人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="city">
          <el-cascader
            ref="regions"
            v-model="save_address.city"
            :separator="'-'"
            :props="{ value: 'label' }"
            :options="CityInfo"
            placeholder="请选择省/市/区/街道"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            type="textarea"
            v-model="save_address.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model="save_address.phone"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="default" :inline="true" class="mb0">
          <el-checkbox v-model="save_address.default"
            >是否为默认地址</el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm('save_address')" round class="button"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- address_xg end -->
    <div class="successful" v-if="successful">
      <img src="../../assets/shopping/successful.png" />
      <h4>兑换成功</h4>
      <p>
        <span v-if="ParentType == 65"
          >商品将在48小时内寄出<br />您可以到个人中心查看兑换订单</span
        >
        <span v-else
          >优惠券已经存入您的优惠券账户<br />您可以到个人中心查看兑换订单</span
        >
      </p>
      <el-button @click="successfulT" round class="button">确定</el-button>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    return {
      CoverImg: "",
      title: "",
      num: "",
      dhjf: "",
      xyjf: "",
      ljyycg: false,
      ParentType: "",
      address: [],
      default1: 0,
      addresslength: true,
      address_zzc: false,
      address_hidden: false,
      news: "",
      save_address: {
        name: "",
        city: "",
        address: "",
        phone: "",
        default: false
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入收件人姓名",
            trigger: "blur"
          },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 5 个字符",
            trigger: "blur"
          }
        ],
        city: [
          {
            required: true,
            message: "请选择所在区域",
            trigger: "change"
          }
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur"
          }
        ]
      },
      CityInfo: [""],
      successful: false
    };
  },
  methods: {
    // 选择地址
    xuanze(index) {
      this.default1 = index;
      this.addressId = this.address[index].Id;
      // console.log(this.addressId)
    },
    // 新增地址
    news_address() {
      this.address_zzc = true;
      this.address_hidden = true;
      this.news = true;
    },
    // 点击修改地址
    modify(index) {
      // console.log(this.address[index].Region)
      this.addressId = this.address[index].Id;
      this.address_zzc = true;
      this.address_hidden = true;
      this.news = false;
      this.save_address.name = this.address[index].Name;
      this.save_address.city = this.address[index].Region.split("-");
      this.save_address.address = this.address[index].DetailedAddress;
      this.save_address.phone = this.address[index].Phone;
      this.save_address.default = this.address[index].Default;
    },
    // 关闭弹窗
    address_close(formName) {
      this.address_zzc = false;
      this.address_hidden = false;
      this.successful = false;
      this.save_address.name = "";
      this.save_address.city = "";
      this.save_address.address = "";
      this.save_address.phone = "";
      this.save_address.default = "";
    },
    // 提交地址
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var Name = this.save_address.name;
          var Region = this.save_address.city.join("-");
          var DetailedAddress = this.save_address.address;
          var Phone = this.save_address.phone;
          var Default = this.save_address.default;
          if (this.news) {
            this.$http
              .post(
                "https://schoolapi.eiceducation.com.cn/api/DeliveryAddress",
                {
                  Id: 0,
                  Name: Name,
                  Phone: Phone,
                  Region: Region,
                  DetailedAddress: DetailedAddress,
                  Default: Default
                },
                {
                  headers: {
                    token: that.tokenkey
                  }
                }
              )
              .then(function(result) {
                // console.log(result)
                if (result.status == 200) {
                  that.addressLi();
                  that.address_close();
                  this.$refs[formName].resetFields();
                }
              })
              .catch(function(error) {
                // console.log(error);
              });
          } else {
            var addressId = this.addressId;
            this.$http
              .put(
                "https://schoolapi.eiceducation.com.cn/api/DeliveryAddress",
                {
                  Id: addressId,
                  Name: Name,
                  Phone: Phone,
                  Region: Region,
                  DetailedAddress: DetailedAddress,
                  Default: Default
                },
                {
                  headers: {
                    token: that.tokenkey
                  }
                }
              )
              .then(function(result) {
                // console.log(result)
                if (result.status == 200) {
                  that.addressLi();
                  that.address_close();
                  this.$refs[formName].resetFields();
                }
              })
              .catch(function(error) {
                // console.log(error);
              });
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 提交订单
    submit_order() {
      let that = this;
      // console.log(this.addressId)
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/GoodsOrder",
          {
            GoodsId: that.$route.query.shopId,
            Count: that.$route.query.num,
            AddessId: that.addressId
          },
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // console.log(result)
          that.address_zzc = true;
          that.successful = true;
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    successfulT() {
      this.address_zzc = false;
      this.successful = false;
      this.$router.push("/shop_list");
    },
    // 取消订单
    cancel_order() {
      this.$router.push({
        path: "/shop_details",
        query: {
          shopId: this.$route.query.shopId
        }
      });
    },
    // 更新地址列表
    addressLi() {
      var that = this;
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/DeliveryAddress", {
          headers: {
            token: that.tokenkey,
            Accept: "application/json; charset=utf-8"
          }
        })
        .then(function(result) {
          // console.log(result)
          that.address = result.data.results;
        })
        .catch(function(error) {
          // console.log(error);
        });
    }
  },
  created: function() {
    var that = this;
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/index");
    }
    this.tokenkey = that.$cookies.get("token");
    if ((this.tokenkey, this.$route.query.shopId, this.$route.query.num)) {
      that.num = this.$route.query.num;
      // 商品详情接口
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/Goods/" +
            this.$route.query.shopId
        )
        .then(function(result) {
          // // console.log(result)
          that.CoverImg = result.data.results.CoverImg;
          that.title = result.data.results.Title;
          that.dhjf = result.data.results.ConversionPrice;
          that.xyjf =
            result.data.results.ConversionPrice * that.$route.query.num;
          that.ParentType = result.data.results.ParentType;
        })
        .catch(function(error) {
          // console.log(error);
        });
      // 收获地址
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/DeliveryAddress", {
          headers: {
            token: that.tokenkey,
            Accept: "application/json; charset=utf-8"
          }
        })
        .then(function(result) {
          // console.log(result)
          that.address = result.data.results;
          that.addressId = result.data.results[0].Id;
          if (result.data.count > 5) {
            that.addresslength = false;
          } else {
            that.addresslength = true;
          }
        })
        .catch(function(error) {
          // console.log(error);
        });
    } else {
      this.$router.push({
        path: "/shop_list"
      });
    }
  },
  mounted: function() {
    //自动触发写入的函数
    var that = this;
    this.$http
      .get("http://localhost:8080/static/city-data2.json")
      .then(function(resp) {
        // console.log(resp)
        that.CityInfo = resp.data;
      })
      .catch(function(error) {
        // console.log(error)
      });
  }
};
</script>

<style scoped id="shop_order">
#shop_order {
  background: #fafafa;
  padding-bottom: 36px;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt {
  width: 1142px;
  font-size: 20px;
  color: #333;
  line-height: 56px;
  text-align: left;
  padding-left: 38px;
  background: url(../../assets/shopping/shop_ico1.png) 19px no-repeat;
  margin: 0 auto;
}

.main {
  width: 1180px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  padding-bottom: 60px;
}

.main_shop {
  width: 1080px;
  margin: 0 auto;
  padding: 28px 0;
}

.main_shop dt {
  width: 120px;
  height: 120px;
  overflow: hidden;
  float: left;
  margin-right: 16px;
}

.main_shop dt img {
  width: 100%;
}

.main_shop dd {
  width: 900px;
  float: left;
  text-align: left;
}

.main_shop dd h3 {
  font-size: 16px;
  line-height: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}

.main_shop dd p {
  font-size: 12px;
  color: #333;
  line-height: 18px;
}

.main_shop dd p.red {
  color: #ff3250;
}

.shop_heng {
  width: 1080px;
  height: 4px;
  background: #f5f6f6;
  border-radius: 4px;
  margin: 0 auto;
  margin-bottom: 18px;
}

.Shipping_address {
  width: 1080px;
  margin: 0 auto;
}

.Shipping_address h2 {
  font-size: 18px;
  line-height: 42px;
  text-align: left;
  font-weight: 500;
  border-bottom: 1px #d5d5d5 solid;
  margin-bottom: 20px;
}

.Shipping_address ul li {
  width: 324px;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 6px;
  border: 1px solid #d5d5d5;
  float: left;
  margin-right: 8px;
  margin-bottom: 12px;
  padding: 0 14px;
  text-align: left;
}

.Shipping_address ul li:nth-child(3n) {
  margin-right: 0;
}

.Shipping_address ul li h3 {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  border-bottom: 1px #d5d5d5 solid;
  padding-top: 8px;
  font-weight: 500;
}

.Shipping_address ul li p {
  font-size: 12px;
  line-height: 16px;
  color: #666666;
  min-height: 32px;
  padding: 5px 0;
}

.Shipping_address ul li span {
  display: none;
  font-size: 12px;
  color: #ff7e7e;
  cursor: pointer;
}

.Shipping_address ul li.btn2 {
  border-color: #ff797b;
  background: url(../../assets/shopping/shop_ico2.png) 296px 40px no-repeat;
}

.Shipping_address ul li.btn2 span {
  display: block;
}

.gl_address {
  height: 24px;
  padding: 12px 24px;
  border-bottom: 1px #d5d5d5 solid;
}

.gl_address span {
  font-size: 14px;
  color: #ff7e7e;
  line-height: 24px;
  float: right;
}

.shop_btn {
  padding-top: 16px;
}

.shop_btn span {
  display: block;
  float: left;
  width: 120px;
  height: 38px;
  background: #f5f6f6;
  border-radius: 23px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  line-height: 38px;
  margin-right: 8px;
  cursor: pointer;
}

.shop_btn button {
  display: block;
  float: left;
  width: 120px;
  height: 38px;
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 23px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
  border: none;
}

.shop_btn button.btn {
  background: #f5f6f6;
  font-size: 16px;
  color: #999999;
  cursor: not-allowed;
}

.zzc {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.address_xg {
  width: 460px;
  height: 490px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  position: fixed;
  left: 50%;
  top: 20%;
  margin-left: -230px;
  z-index: 9;
  padding-top: 70px;
}

.address_xg .address_close {
  width: 38px;
  height: 38px;
  position: absolute;
  left: 20px;
  top: 20px;
  cursor: pointer;
}

.address_xg .address_close img {
  width: 100%;
}

.address_xg .mb0 {
  margin-bottom: 10px;
}

.address_xg h2 {
  width: 380px;
  font-size: 20px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-weight: 500;
  margin: 0 auto;
  margin-bottom: 15px;
}

.demo-save_address {
  width: 380px;
  margin: 0 auto;
  text-align: left;
}

/deep/ .demo-save_address .el-textarea__inner {
  resize: none;
  height: 100px;
}

/deep/ .demo-save_address .el-input__inner {
  width: 300px;
}

/deep/ .demo-save_address .button {
  width: 160px;
  height: 42px;
  border-radius: 30px;
}

.news_address {
  display: block;
  width: 200px;
  height: 42px;
  text-align: left;
  margin-bottom: 10px;
}

.successful {
  width: 460px;
  height: 446px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  padding-top: 74px;
  position: fixed;
  top: 20%;
  left: 50%;
  margin-left: -230px;
  z-index: 9;
  text-align: center;
}

.successful h4 {
  font-size: 20px;
  color: #333333;
  line-height: 40px;
  margin-bottom: 20px;
}

.successful p {
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  margin-bottom: 38px;
}
</style>



// WEBPACK FOOTER //
// src/page2/shopping/shop_order.vue